import { get } from "./api";
import URLS from "../constants/api";

export const getMembershipTypes = async (
) => {

  const response = await get(URLS.GET_MEMBERSHIP_TYPE);
  return response;
};
